<tiime-dialog [isLoading]="isLoading()" (cancel)="cancel()">
  <span mat-dialog-title>Contacter le support</span>
  <mat-dialog-content class="dialog-content" mat-dialog-content>
    <form [formGroup]="contactSupportForm">
      <div tiimeForm>
        <div tiimeFormColumn>
          <tiime-input-container
            tiimeFormInputContainer
            contentId="reason"
            label="Motif de la demande"
            [required]="true"
            [errorMessage]="contactSupportForm.reasonErrorMessage?.message"
          >
            <tiime-select id="reason" formControlName="reason">
              <div tiimeSelectOptions>
                @for (reason of CONTACT_SUPPORT_REASON_LABEL | keyvalue; track $index) {
                  <mat-option [value]="reason.key">{{ reason.value }}</mat-option>
                }
              </div>
            </tiime-select>
          </tiime-input-container>
          <tiime-input-container
            tiimeFormInputContainer
            contentId="subject"
            label="Sujet"
            [required]="true"
            [errorMessage]="contactSupportForm.subjectErrorMessage?.message"
          >
            <input id="subject" type="text" placeholder="Sujet" formControlName="subject" autocomplete="off" />
          </tiime-input-container>
          <tiime-input-container
            tiimeFormInputContainer
            contentId="description"
            label="Description"
            [required]="true"
            [errorMessage]="contactSupportForm.descriptionErrorMessage?.message"
          >
            <textarea
              id="description"
              type="text"
              placeholder="Description"
              formControlName="description"
              cdkTextareaAutosize
              cdkAutosizeMinRows="6"
              cdkAutosizeMaxRows="10"
            ></textarea>
          </tiime-input-container>
          <div class="attachment-container">
            @for (fileCtrl of contactSupportForm.files.controls; track $index) {
              <mat-chip-list>
                <app-attachment-item
                  [canBeDeleted]="true"
                  [attachmentName]="fileCtrl.value.name"
                  (remove)="removeFile($index)"
                ></app-attachment-item>
              </mat-chip-list>
            }
            <app-add-files-button
              [acceptedTypes]="acceptedFileTpes"
              (filesAdded)="filesAdded($event)"
            ></app-add-files-button>
          </div>
        </div>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">
    <button tiime-button color="accent" strocked large (click)="cancel()">Annuler</button>
    <button tiime-button color="accent" large raised (click)="send()">Envoyer</button>
  </mat-dialog-actions>
</tiime-dialog>
